import InspectionDBStatus from "./inspection-db-status.entity";

class InspectionStepLocalDB {
  public plate: string;
  public uniqueIdentifier: string;
  public createDate: string;
  public photo: any;
  public appletSubgroupId: string;
  public id: number;
  public status: string;
  public accuracy: number;
  public latitude: number;
  public longitude: number;
  public appletProfileId: string;
  public vehicleData: any;

  constructor(data: any = {}) {
    this.plate = data.plate || '';
    this.uniqueIdentifier = data.unique_identifier || '';
    this.createDate = data.create_date || '';
    this.photo = data.photo || {};
    this.appletSubgroupId = data.applet_subgroup_id || '';
    this.id = data.id || 0;
    this.status = data.status || InspectionDBStatus.WAITING;
    this.accuracy = data.accuracy || 0;
    this.latitude = data.latitude || 0;
    this.longitude = data.longitude || 0;
    this.appletProfileId = data.applet_profile_id || '';
    this.vehicleData = data.vehicle_data || null;
  }

  public formatPayload() {
    return {
      plate: this.plate,
      photo: this.photo,
      status: this.status,
      create_date: this.createDate,
      unique_identifier: this.uniqueIdentifier,
      applet_subgroup_id: this.appletSubgroupId,
      accuracy: this.accuracy,
      latitude: this.latitude,
      longitude: this.longitude,
      applet_profile_id: this.appletProfileId,
      vehicle_data: this.vehicleData
    }
  }

  public formatUpdatePayload() {
    return {
      id: this.id,
      plate: this.plate,
      photo: this.photo,
      status: this.status,
      create_date: this.createDate,
      unique_identifier: this.uniqueIdentifier,
      applet_subgroup_id: this.appletSubgroupId,
      accuracy: this.accuracy,
      latitude: this.latitude,
      longitude: this.longitude,
      applet_profile_id: this.appletProfileId,
      vehicle_data: this.vehicleData
    }
  }
}

export default InspectionStepLocalDB;
